<template>
    <div class="infocell fr" @click="go(`infodetail?id=${info.information_id}`)">
        <div class="info_left fc jsb">
            <div>
                <p class="fz16 black mb10">{{info.information_title}}</p>
                <p class="ellipsis-2line fz12 grey">{{info.information_desc}}</p>
            </div>
            <div class="grey fz12 fr ac jsb">
                <div class="fr">
                    <p class="mr10">文章来源:{{info.member_nick_name}}</p>
                    <p>发布时间:{{info.create_time}}</p>
                </div>
                <div class="fr ac cursor" @click.stop="insertCollection">
                    <i class="fz16 el-icon-star-off" v-if="info.is_collection != 1" />
                    <i class="fz16 el-icon-star-on blue" v-else />
                    <span class="fz12 black ml10">收藏（{{info.collection_count}}）</span>
                </div>
            </div>
        </div>
        <el-image :src="info.information_imgs.split(',')[0]" lazy></el-image>
    </div>
</template>

<script>
export default {
    props: {
        info: Object
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {},
    methods: {
        insertCollection() {
            this.$emit("insertCollection", this.info.information_id);
        }
    },
    components: {}
};
</script>

<style scoped lang="scss">
.infocell {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e5e5e5;
    .info_left {
        width: calc(100% - 120px);
    }
    .el-image {
        margin-left: 20px;
        width: 100px;
        height: 100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoCell.vue